/**
 * Created by ivan on 11.04.18.
 */

const DynamiteToolbarItem = function () {
    ToolbarItem.call(this, ToolbarItem.DYNAMITE);

    this.onUpdateDragState = function () {};
};

DynamiteToolbarItem.prototype = Object.create(ToolbarItem.prototype);
DynamiteToolbarItem.prototype.constructor = DynamiteToolbarItem;

DynamiteToolbarItem.prototype.getPrice = function () {
    return `$$${DynamiteToolbarItem.PRICE}`;
};

DynamiteToolbarItem.prototype.onFollowPointer = function (touch) {
    const map = Map2d.currentMap;
    const cell = map.getMapView().getCellByTouch(touch);

    if (!map.isValid(cell.x, cell.y) || this.invalidTouch(touch)) {
        this.clearHighlight();
        return;
    }

    const data = Families[DynamiteToolbarItem.UNIT.code].units[DynamiteToolbarItem.UNIT.stage];

    this.clearHighlight();
    this.highlightCells(cell, data.dynamite.radius);
};

DynamiteToolbarItem.prototype.dragAction = function (touch) {
    this.clearHighlight();

    const map = Map2d.currentMap;
    const mapView = map.getMapView();

    const cell = mapView.getCellByTouch(touch);

    if (!this.invalidTouch(touch) && this.canPlaceDynamite(cell) && cleverapps.user.spendHard(cleverapps.EVENTS.SPENT.DYNAMITE, DynamiteToolbarItem.PRICE)) {
        const unit = new Unit(DynamiteToolbarItem.UNIT);
        unit.setPosition(cell.x, cell.y);
        Map2d.currentMap.onAddUnit(unit.x, unit.y, unit);
        Map2d.currentMap.onUnitAvailable(unit);

        const dynamite = unit.findComponent(Dynamite);
        dynamite.explode();

        return true;
    }

    return false;
};

DynamiteToolbarItem.prototype.isVisible = function () {
    return cleverapps.meta.getSelectedLocation().locationConfig.usesDynamite;
};

DynamiteToolbarItem.prototype.clearHighlight = function () {
    this.lastCell = undefined;

    if (this.highlights) {
        this.highlights.forEach((highlight) => {
            highlight.remove();
        });
        this.highlights = undefined;
    }
};

DynamiteToolbarItem.prototype.highlightCells = function (cell, radius) {
    if (cc.pointEqualToPoint(this.lastCell, cell)) {
        return;
    }

    const map = Map2d.currentMap;

    this.lastCell = cell;
    this.highlights = [];

    const error = !this.canPlaceDynamite(cell);
    if (error) {
        const highlight = new Highlight(cell.x, cell.y, {
            isErrorLight: error
        });

        this.highlights.push(highlight);

        map.onAdd(Map2d.LAYER_UNITS, highlight.x, highlight.y, highlight);
        return;
    }

    const shape = Dynamite.calcExplosionShape(radius);
    const affected = [];

    shape.forEach((part) => {
        let x = cell.x + part.x;
        let y = cell.y + part.y;

        if (!map.isGround(x, y) && !map.isWaterUnit(x, y) || map.getFog(x, y)) {
            return;
        }

        let unit = map.getUnit(x, y);
        if (unit) {
            if (unit.head) {
                unit = unit.head;
            }

            if (affected.indexOf(unit) !== -1) {
                return;
            }

            x = unit.x;
            y = unit.y;
            affected.push(unit);
        }

        const highlight = new Highlight(x, y, {
            isErrorLight: Dynamite.canExplodeUnit(unit),
            unit
        });

        this.highlights.push(highlight);

        map.onAdd(Map2d.LAYER_UNITS, highlight.x, highlight.y, highlight);
    });
};

DynamiteToolbarItem.prototype.canPlaceDynamite = function (cell) {
    const map = Map2d.currentMap;
    return map.isGround(cell.x, cell.y) && !map.getFog(cell.x, cell.y) && !map.getUnit(cell.x, cell.y);
};

DynamiteToolbarItem.prototype.invalidTouch = function (touch) {
    const toolbarBg = ComponentUtils.findChildByName(cleverapps.toolbar.onGetView(), "bg");
    return toolbarBg.hasTouch(touch);
};

DynamiteToolbarItem.PRICE = 99;
DynamiteToolbarItem.UNIT = { code: "advdynamite", stage: 0 };
